module.exports = __webpack_public_path__ + "zvetseni-prsou_14_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_14_after.jpg
// module id = 1301
// module chunks = 0